import { render, staticRenderFns } from "./MarPriceRecord.vue?vue&type=template&id=431926fa&scoped=true&"
import script from "./MarPriceRecord.vue?vue&type=script&lang=js&"
export * from "./MarPriceRecord.vue?vue&type=script&lang=js&"
import style0 from "./MarPriceRecord.vue?vue&type=style&index=0&id=431926fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431926fa",
  null
  
)

export default component.exports